import VideoThumbnail from '@repo/ui/src/components/VideoThumbnail';
import { classNames } from '@repo/ui/src/utils/classNames';
import { Anchor } from '@repo/ui/src/components/Anchor';
import Button, { ButtonVariant } from '@repo/ui/src/components/Button';
import { LinkProps, MediaType, YoutubeLinkProps } from '@repo/ui/src/types';
import buildImageSrc from '@repo/ui/src/functions/image-functions-aspect-ratio';

interface Props {
  title?: string;
  description?: string;
  uploadedThumbnail?: MediaType[];
  link?: {
    link: LinkProps;
  };
  asset?: MediaType;
  name?: string;
  duration?: string;
  youtubeLink?: YoutubeLinkProps;
  thumbnailUrl?: string;
  darkMode?: boolean;
  onClick?: () => void;
}

const PlaylistCard = ({
  title,
  description,
  uploadedThumbnail,
  link,
  asset,
  name,
  duration,
  youtubeLink,
  thumbnailUrl,
  darkMode,
  onClick,
}: Props) => {
  const videoTitle = name || title;
  const thumbnail =
    asset ||
    (uploadedThumbnail
      ? uploadedThumbnail[0]
      : youtubeLink?.uploadedThumbnail
        ? youtubeLink.uploadedThumbnail[0]
        : null);
  const builtThumbnailUrl = thumbnail
    ? buildImageSrc(thumbnail, 500, 2, 1)
    : 'https://i8.amplience.net/i/traeger/black-image/?w=500&h=300&sm=c&scaleFit=poi&$poi2$';
  const cardImage = thumbnailUrl || builtThumbnailUrl || youtubeLink?.thumbnailUrl;

  return (
    <div
      className={classNames(
        'tw-flex tw-flex-col tw-h-full',
        darkMode ? 'tw-bg-neutral-700 tw-text-white' : 'tw-bg-white tw-text-neutral-700',
      )}
    >
      <div className="tw-h-full tw-pb-6">
        <VideoThumbnail
          title={title}
          imgUrl={cardImage}
          duration={duration || youtubeLink?.duration}
          onClick={onClick}
        />
        {videoTitle && <h6 className="tra-text-web-heading-6 tw-m-6">{videoTitle}</h6>}
        {description && (
          <div className="tw-hidden sm:tw-block">
            <hr className="tw-border-2 tw-w-6 tw-border-brand-300 tw-ml-6" />
            <p
              className={classNames(
                darkMode && 'tw-text-white',
                'tra-text-web-body-l tw-pt-4 tw-px-6 tw-line-clamp-4',
              )}
            >
              {description}
            </p>
          </div>
        )}
      </div>
      {(link?.link?.link || link?.link?.externalLink) && (
        <div className="tw-p-6">
          <Button
            as={Anchor}
            {...link.link}
            variant={ButtonVariant.knife}
            dark={darkMode}
            dataTestId="playlist-card-link-button"
          >
            {link.link.displayName}
          </Button>
        </div>
      )}
    </div>
  );
};

export default PlaylistCard;
